import { Injectable } from '@angular/core';
import { AxisInputNumberPipe } from 'axis-components';
import { Utils } from 'axis-ui-generator';
import { CHECKBOXHEADINGLITETravel, CHECKBOXLITEBAG, CHECKBOXLITEPERSONAL, CHECKBOXLITTHIRDPARTY, insuranceTypeCheckBox } from 'src/app/features/fnol/config/fnol-constants';
import { DataStoreService } from 'src/app/features/fnol/services/data-store.service';
import { FnolService } from 'src/app/features/fnol/services/fnol.service';
import { ClaimtypeAbstractService } from './claimtype-abstract.service';
@Injectable({
  providedIn: 'root'
})
export class ClaimTypeAUService extends ClaimtypeAbstractService {

  momentDateFormat = 'DD-MM-YYYY';
  personalAccident = [];
  permanantdiablity;
  leavebenifit;
  otherClaimShow;
  accidentalDeatBoolean;
  foundmedical;
  policyDetails;
  phoneCodeList;
  insuredDetails = null;
  step2 = 'fnol-claimtype-details';
  step1 = 'fnol-claimant-info';
  country;
  personalDetails = [];
  hsotDrInfo = [];
  data;
  uiStructure: any;
  uiData: any;
  constructor(
    public dataStoreService: DataStoreService, public axisPipe: AxisInputNumberPipe,
    private fnolService: FnolService,
  ) {
    super();
  }

  getClaimTypeData() {
    if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Travel') {
      return this.getTravelDetails(this.step2);
    }
    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Other') {
      return this.getOtherDetails();
    }

    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Personal Accident') {
      return this.personalAccidentPayload();
    }
  }

  /**
   * Travel icon from step 2
   * @param step
   * @returns
   */
  getTravelDetails(step) {
    const travelDetailsInfo = [];
    travelDetailsInfo.push(
      {
        name: this.getData('claimBenefits', 'label', step)['label'] === 'Select Claim Type' ? 'What is the cause of your claim?' : '',
        value: this.dataStoreService.get(step).uiData['claimBenefits']
      }
    );

    const travelInfo = ['heading', 'dateSymptom', 'dateVisit', 'diagnosisIllness'];

    const uiData = this.dataStoreService.get(step).uiData;
    travelInfo.forEach(fieldName => {

      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: 'Travel Details',
            value: 'heading'
          }
        );
      } else {
        if (fieldName === 'diagnosisIllness' && fieldName.indexOf('diagnosisIllness') > -1) {
          travelDetailsInfo.push(
            {
              name: this.getData('diagnosisIllness', 'label', step)['label'],
              value: this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisIllness']?.name
            });
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step)
            });
        }
      }
    });

    const travelBenefit = ['heading', 'chooseClaimTypeIllness'];
    travelBenefit.forEach(fieldName => {

      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: 'Travel Benefits',
            value: 'heading'
          });
      }
      else {
        const newArray = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'];
        CHECKBOXHEADINGLITETravel.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(headingValue);
            }
          });
        });
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: newArray.join(', ')
          });
      }
    });

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingIncident') !== undefined) {
      const travelBenefitType = ['heading', 'injuredSick'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Medical Incident',
              value: 'heading'
            });
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.dataStoreService.get('fnol-claimtype-details').uiData['injuredSick'] === 'wasInjured' ? 'I was injured' : 'I was sick',
            }
          );
        }
      });

      if (uiData['injuredSick'] === 'wasInjured' && uiData['injuredSick'] !== null) {
        const insurance = ['claimDescribeWords', 'whenOccur', 'diagnosisInjured', 'medicalExpenseInjured', 'travelAccident', 'similarComplaintPast', 'privateHealthInsurancefund'];
        insurance.forEach(fieldName => {

          if (fieldName === 'medicalExpenseInjured') {
            const medicalDetails = ['westernMedicine', 'mobileAdd', 'dentalTreatment', 'sum'];
            travelDetailsInfo.push(
              {
                name: 'Cost of Treatment',
                value: 'heading'
              });
         
            medicalDetails.forEach(key => {
              travelDetailsInfo.push(
                {
                  name: key === 'westernMedicine' ? 'Medical Treatment' : key === 'mobileAdd' ? 'Mobility Aid' : key === 'dentalTreatment' ? 'Dental Treatment' : key === 'sum' ? 'Total Claim Amount' : '',
                  // value: medicalExpenseInjured[key] && medicalExpenseInjured?.currency !== undefined ? medicalExpenseInjured?.currency?.label + ' ' + this.decimalConverter(medicalExpenseInjured[key], 'SG') : medicalExpenseInjured?.currency !== undefined ? medicalExpenseInjured?.currency?.label + ' 0.00' : ' 0.00'
                  value: this.dataStoreService.get(this.step2).uiData['medicalExpenseInjured'][key] ? ' ' + uiData['medicalExpenseInjured'].currency.label + ' ' + this.decimalConverter(this.dataStoreService.get(this.step2).uiData['medicalExpenseInjured'][key], 'SG') : ' ' + uiData['medicalExpenseInjured'].currency.label + ' 0.00'
                }
              );
            });
          }

          if (fieldName === 'diagnosisInjured') {
            if (fieldName.indexOf('diagnosisInjured') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisInjured', 'label', step)['label'],
                  value: this.getData('diagnosisInjured', '', step),
                });
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisInjured'].id === '8') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisOther', 'label', step)['label'],
                  value: this.getData('diagnosisOther', '', step),
                }
              );
            }
          }

          if (fieldName === 'travelAccident') {
            if (uiData['travelAccident'] === 'Yes' && uiData['travelAccident'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('travelAccident', 'label', step)['label'],
                  value: this.getData('travelAccident', '', step),
                },
                {
                  name: this.getData('claimDescribe', 'label', step)['label'],
                  value: this.getData('claimDescribe', '', step),
                },
                {
                  name: this.getData('nameCost', 'label', step)['label'],
                  value: this.checkCustom('nameCost', '', step, this.axisPipe),
                });
            } else {
              travelDetailsInfo.push({
                name: this.getData('travelAccident', 'label', step)['label'],
                value: this.getData('travelAccident', '', step),
              });
            }
          } else {
            if (fieldName !== 'medicalExpenseInjured' && fieldName !== 'diagnosisInjured' && fieldName !== 'similarComplaintPast' && fieldName !== 'privateHealthInsurancefund') {
              travelDetailsInfo.push({
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              });
            }
          }
          // new added for past compliant and private health insurance fund
          if (fieldName === 'similarComplaintPast') {
            if (uiData['similarComplaintPast'] === 'Yes' && uiData['similarComplaintPast'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('similarComplaintPast', 'label', step)['label'],
                  value: this.getData('similarComplaintPast', '', step),
                },
                {
                  name: this.getData('provideDetailsSimilarComplaint', 'label', step)['label'],
                  value: this.getData('provideDetailsSimilarComplaint', '', step),
                },
              );
            } else {
              travelDetailsInfo.push({
                name: this.getData('similarComplaintPast', 'label', step)['label'],
                value: this.getData('similarComplaintPast', '', step),
              });
            }
          }
          if (fieldName === 'privateHealthInsurancefund') {
            if (uiData['privateHealthInsurancefund'] === 'Yes' && uiData['privateHealthInsurancefund'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('privateHealthInsurancefund', 'label', step)['label'],
                  value: this.getData('privateHealthInsurancefund', '', step),
                },
                {
                  name: this.getData('provideDetailsPrivateHealth', 'label', step)['label'],
                  value: this.getData('provideDetailsPrivateHealth', '', step),
                },
              );
            } else {
              travelDetailsInfo.push({
                name: this.getData('privateHealthInsurancefund', 'label', step)['label'],
                value: this.getData('privateHealthInsurancefund', '', step),
              });
            }
          }
        });
      } else if (uiData['injuredSick'] === 'wasSick' && uiData['injuredSick'] !== null) {
        const insurance = ['claimDescribeWordsSick', 'whenOccurSick', 'diagnosisSickInjuredSick', 'medicalExpenseSick', 'travelAccidentSick', 'similarComplaintPastWasSick', 'privateHealthInsurancefundWasSick'];
        insurance.forEach(fieldName => {

          if (fieldName === 'medicalExpenseSick') {
            const medicalDetails = ['heading', 'westernMedicine', 'mobileAdd', 'dentalTreatment', 'sum'];
            medicalDetails.forEach(key => {
              if (key === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Cost of Treatment',
                    value: 'heading'
                  });
              } else {
                travelDetailsInfo.push(
                  {
                    name: key === 'westernMedicine' ? 'Medical Treatment' : key === 'mobileAdd' ? 'Mobility Aid' : key === 'dentalTreatment' ? 'Dental Treatment' : key === 'sum' ? 'Total Claim Amount' : '',
                    value: this.dataStoreService.get(this.step2).uiData['medicalExpenseSick'][key] ? ' ' + uiData['medicalExpenseSick'].currency.label + ' ' + this.decimalConverter(this.dataStoreService.get(this.step2).uiData['medicalExpenseSick'][key], 'SG') : ' ' + uiData['medicalExpenseSick'].currency.label + ' 0.00'

                  }
                );
              }
            });
          }

          if (fieldName === 'diagnosisSickInjuredSick') {
            if (fieldName.indexOf('diagnosisSickInjuredSick') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisSickInjuredSick', 'label', step)['label'],
                  value: this.getData('diagnosisSickInjuredSick', '', step),
                });
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickInjuredSick'].id === '13') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisSickOtherSick', 'label', step)['label'],
                  value: this.getData('diagnosisSickOtherSick', '', step),
                }
              );
            }
          }

          if (fieldName === 'travelAccidentSick') {
            if (uiData['travelAccidentSick'] === 'Yes' && uiData['travelAccidentSick'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('travelAccidentSick', 'label', step)['label'],
                  value: this.getData('travelAccidentSick', '', step),
                },
                {
                  name: this.getData('claimDescribeSick', 'label', step)['label'],
                  value: this.getData('claimDescribeSick', '', step),
                },
                {
                  name: this.getData('nameCostSick', 'label', step)['label'],
                  value: this.checkCustom('nameCostSick', '', step, this.axisPipe),
                });
            } else {
              travelDetailsInfo.push({
                name: this.getData('travelAccidentSick', 'label', step)['label'],
                value: this.getData('travelAccidentSick', '', step),
              });
            }
          } else {
            if (fieldName !== 'medicalExpenseSick' && fieldName !== 'diagnosisSickInjuredSick' && fieldName !== 'similarComplaintPastWasSick' && fieldName !== 'privateHealthInsurancefundWasSick') {
              travelDetailsInfo.push({
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              });
            }
          }
          // new added for past compliant and private health insurance fund
          if (fieldName === 'similarComplaintPastWasSick') {
            if (uiData['similarComplaintPastWasSick'] === 'Yes' && uiData['similarComplaintPastWasSick'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('similarComplaintPastWasSick', 'label', step)['label'],
                  value: this.getData('similarComplaintPastWasSick', '', step),
                },
                {
                  name: this.getData('provideDetailsSimilarComplaintWasSick', 'label', step)['label'],
                  value: this.getData('provideDetailsSimilarComplaintWasSick', '', step),
                },
              );
            } else {
              travelDetailsInfo.push({
                name: this.getData('similarComplaintPastWasSick', 'label', step)['label'],
                value: this.getData('similarComplaintPastWasSick', '', step),
              });
            }
          }
          if (fieldName === 'privateHealthInsurancefundWasSick') {
            if (uiData['privateHealthInsurancefundWasSick'] === 'Yes' && uiData['privateHealthInsurancefundWasSick'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('privateHealthInsurancefundWasSick', 'label', step)['label'],
                  value: this.getData('privateHealthInsurancefundWasSick', '', step),
                },
                {
                  name: this.getData('provideDetailsPrivateHealthWasSick', 'label', step)['label'],
                  value: this.getData('provideDetailsPrivateHealthWasSick', '', step),
                },
              );
            } else {
              travelDetailsInfo.push({
                name: this.getData('privateHealthInsurancefundWasSick', 'label', step)['label'],
                value: this.getData('privateHealthInsurancefundWasSick', '', step),
              });
            }
          }
        });
      }
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingDelayed') !== undefined) {
      const travelBenefitType = ['heading', 'originalFlightNumber', 'originalArriveDate', 'originalArriveTime', 'revisedFlightNumber', 'actualArriveDate', 'actualArriveTime', 'flightDelayed'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Delayed Flight',
              value: 'heading'
            });
        } else {
          if (fieldName === 'flightDelayed') {
            if (fieldName.indexOf('flightDelayed') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('flightDelayed', 'label', step)['label'],
                  value: this.getData('flightDelayed', '', step),
                }
              );
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['flightDelayed'].id === '7') {
              travelDetailsInfo.push(
                {
                  name: this.getData('provideDetailsTravel', 'label', step)['label'],
                  value: this.getData('provideDetailsTravel', '', step),
                }
              );
            }
          } else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        }
      });
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingTrip') !== undefined) {
      const travelBenefitType = ['heading', 'diagnosisSickTripSick', 'diagnosisSickTripShip', 'diagnosisTripOtherShip', 'claimingForOther', 'dateOfCancellation', 'flightExpense', 'flightRefund', 'accommodationExpense', 'accommodationRefund', 'otherTransportationExpense', 'otherTransportationRefund'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Cancelled Trip',
              value: 'heading'
            });
        } else {
          if (fieldName === 'flightExpense' || fieldName === 'flightRefund' || fieldName === 'accommodationExpense' || fieldName === 'accommodationRefund' || fieldName === 'otherTransportationExpense' || fieldName === 'otherTransportationRefund') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          }

          if (fieldName === 'diagnosisSickTripSick') {
            travelDetailsInfo.push(
              {
                name: this.getData('diagnosisSickTripSick', 'label', step)['label'],
                value: this.getData('diagnosisSickTripSick', '', step),
              });
            const diagnosisSickTripSick = this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripSick'];
            if (diagnosisSickTripSick.id === '7') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisTripOtherSick', 'label', step)['label'],
                  value: this.getData('diagnosisTripOtherSick', '', step),
                }
              );
            }

            if (diagnosisSickTripSick.id === '4') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisSickTripShip', 'label', step)['label'],
                  value: this.getData('diagnosisSickTripShip', '', step),
                });
              if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripShip']?.id === '8') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('diagnosisTripOtherShip', 'label', step)['label'],
                    value: this.getData('diagnosisTripOtherShip', '', step),
                  }
                );
              }
            }
          }

          if (fieldName === 'claimingForOther' || fieldName === 'dateOfCancellation') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        }
      });
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingLost') !== undefined) {
      const travelBenefitType = ['heading', 'itemClaimType'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Baggage / Item Claim',
              value: 'heading'
            });
        } else {
          const newArray = [];
          const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'];
          CHECKBOXLITEBAG.forEach(field => {
            chooseClaimType.forEach(element => {
              if (field.key === element.name) {
                const headingValue = field.heading;
                newArray.push(headingValue);
              }
            });
          });
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: newArray.join(', '),
            }
          );
        }
      });

      const travelBagsDetails = ['travelBags'];
      travelBagsDetails.forEach(fieldName => {
        if (fieldName === 'travelBags') {
          travelDetailsInfo.push(
            {
              name: this.getData('travelBags', 'label', step)['label'],
              value: this.getData('travelBags', '', step),
            }
          );
          if (uiData['travelBags'] === 'Delayed') {
            const delayedDetails = ['landDate', 'timeLand', 'returnedDate', 'timeReturned']
            delayedDetails.forEach(delayedDetail => {
              travelDetailsInfo.push(
                {
                  name: this.getData(delayedDetail, 'label', step)['label'],
                  value: this.getData(delayedDetail, '', step),
                }
              );
            });

            if (uiData['delayedAuthorityReport'] === 'Yes' && uiData['delayedAuthorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('delayedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('delayedAuthorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('delayedAuthorityReportCopy', 'label', step)['label'],
                  value: this.checkCustom('delayedAuthorityReportCopy', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('delayedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('delayedAuthorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['delayedAuthorityReport'] === 'Yes' && uiData['delayedAuthorityReport'] !== null) {
              const copyReport = ['delayedReportAuthorityName', 'delayedReportReferenceNumber', 'delayedPhoneNumber', 'emailDelayed', 'delayedAddressLookup'];
              copyReport.forEach(item => {
                if (item === 'delayedAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(item + 'val', '', step) ? this.getData(item + 'val', '', step) : this.getData(item, '', step).formatted_address ? this.getData(item, '', step).formatted_address : this.getData(item, '', step))
                    }
                  );
                } else if (item === 'delayedPhoneNumber' && uiData['delayedPhoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('delayedPhoneNumber')
                    });
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item, 'label', step)['label'],
                      value: this.checkCustom(item, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }

          if (uiData['travelBags'] === 'Damaged') {
            const delayedDetails = ['bagsTripSick', 'damagedDate', 'provideDetails', 'heading'];
            delayedDetails.forEach(item => {
              if (item === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Bags and/or Items Details',
                    value: 'heading'
                  }
                );
              } 
              if (item === 'bagsTripSick') {
                if (item.indexOf('bagsTripSick') > -1) {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('bagsTripSick', 'label', step)['label'],
                      value: this.getData('bagsTripSick', '', step),
                    }
                  );
                }
                if (this.dataStoreService.get('fnol-claimtype-details').uiData['bagsTripSick'].id === '3') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('otherBagsTripSick', 'label', step)['label'],
                      value: this.getData('otherBagsTripSick', '', step),
                    }
                  );
                }
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(item, 'label', step)['label'],
                    value: this.getData(item, '', step),
                  }
                );
              }
            });

            if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' || ((this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myItems') || (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems'))) {
              const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addItemsMain').fields;
              let tempArray = [];
              bagDamage.forEach((card) => {
              card.fields.forEach((data) => {
                data?.fields?.forEach((item) => {
                  if (item.name.match('nameValue') || item.name.match('repairCost')) {
                    if (this.getData(item.name, '', this.step2)) {
                      tempArray.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                      });
                    }
                  } else {
                    if (this.getData(item.name, '', this.step2)) {
                      tempArray.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.getData(item.name, '', this.step2)
                      });
                    }
                  }
                });
                // Removed logic that pops items from tempArray to ensure all fields, including repairCost, are shown
                travelDetailsInfo.push(...tempArray);
                tempArray = [];
              });
              });
            } else if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems') {
              const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addItemsMain').fields;
              bagDamage.forEach((card) => {
              card.fields.forEach((data, i) => {
                data?.fields.forEach((item) => {
                  if (item.name.match('nameValue')) {
                    if (this.getData(item.name, '', this.step2)) {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                      });
                    }
                  } else if (item.name.match('bagItem') || item.name.match('yearPurchased')) {
                    if (this.getData(item.name, '', this.step2)) {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.getData(item.name, '', this.step2)
                      });
                    }
                  }
                });
              });
              });
            }

            if (uiData['damagedAuthorityReport'] === 'Yes' && uiData['damagedAuthorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('damagedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('damagedAuthorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('damagedAuthorityReportCopy', 'label', step)['label'],
                  value: this.checkCustom('damagedAuthorityReportCopy', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('damagedAuthorityReport', 'label', step)['label'],
                  value: this.checkCustom('damagedAuthorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['damagedAuthorityReport'] === 'Yes' && uiData['damagedAuthorityReport'] !== null) {
              const copyReport = ['damagedReportAuthorityName', 'damagedReportReferenceNumber', 'damagedPhoneNumber', 'emailDamaged', 'damagedAddressLookup'];
              copyReport.forEach(copyReportfield => {
                if (copyReportfield === 'damagedAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportfield, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(copyReportfield + 'val', '', step) ? this.getData(copyReportfield + 'val', '', step) : this.getData(copyReportfield, '', step).formatted_address ? this.getData(copyReportfield, '', step).formatted_address : this.getData(copyReportfield, '', step))
                    }
                  );
                } else if (copyReportfield === 'damagedPhoneNumber' && uiData['damagedPhoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('damagedPhoneNumber')
                    });
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportfield, 'label', step)['label'],
                      value: this.checkCustom(copyReportfield, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }

          if (uiData['travelBags'] === 'Lost or Stolen') {
            const lostStolenDetails = ['stolenLost', 'stolenHappened', 'stolenItem', 'stolenItemWas', 'stolenDate', 'heading'];
            lostStolenDetails.forEach(lostStolenfield => {
              if (lostStolenfield === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Bags and/or Items Details',
                    value: 'heading',
                  });
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(lostStolenfield, 'label', step)['label'],
                    value: this.getData(lostStolenfield, '', step),
                  }
                );
              }
            });

            const lostStolen = Utils.getFieldFromStructure(this.dataStoreService.get(step).uiStructure, 'addStolenMain').fields;
            lostStolen.forEach((card) => {
            card.fields.forEach((data, i) => {
              const matches = data.name.match(/(\d+)/);
              const index1 = matches != null ? matches[0] : '';
              const lostStolenDetail = ['bagItemStolen', 'nameStolenValue', 'yearStolenPurchased', 'heading'];
              lostStolenDetail.forEach((item) => {
                if (item === 'nameStolenValue') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item + index1, 'label', step)['label'],
                      value: this.checkCustom(item + index1, '', step, this.axisPipe)
                    }
                  );
                } else if (item === 'heading') {
                  travelDetailsInfo.push(
                    {
                      name: '',
                      value: 'heading'
                    }
                  );
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item + index1, 'label', step)['label'],
                      value: this.getData(item + index1, '', step)
                    }
                  );
                }
              });
            });
            });

            if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('authorityReport', 'label', step)['label'],
                  value: this.checkCustom('authorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('authorityCopyReport', 'label', step)['label'],
                  value: this.checkCustom('authorityCopyReport', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('authorityReport', 'label', step)['label'],
                  value: this.checkCustom('authorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
              const copyReport = ['nameAuthority', 'referenceNumber', 'phoneNumber', 'emailStolen', 'myAddressLookup'];
              copyReport.forEach(copyReportfields => {
                if (copyReportfields === 'myAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportfields, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(copyReportfields + 'val', '', step) ? this.getData(copyReportfields + 'val', '', step) : this.getData(copyReportfields, '', step).formatted_address ? this.getData(copyReportfields, '', step).formatted_address : this.getData(copyReportfields, '', step))
                    }
                  );
                } else if (copyReportfields === 'phoneNumber' && uiData['phoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('phoneNumber')
                    });
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(copyReportfields, 'label', step)['label'],
                      value: this.checkCustom(copyReportfields, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }
        }
      });
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'myRentalVehicle') !== undefined) {

      travelDetailsInfo.push(
        {
          name: 'Rental Vehicle Incident',
          value: 'heading'
        });
      travelDetailsInfo.push(
        {
          name: this.getData('dateOfIncident', 'label', step)['label'],
          value: this.getData('dateOfIncident', '', step)
        },
        {
          name: this.getData('valueofExcess', 'label', step)['label'],
          value: this.checkCustom('valueofExcess', '', step, this.axisPipe)
        },
        {
          name: this.getData('tellWhatHappenedRental', 'label', step)['label'],
          value: this.getData('tellWhatHappenedRental', '', step)
        }
      );

      if (uiData['reportAuthority'] === 'Yes' && uiData['reportAuthority'] !== null) {
        travelDetailsInfo.push(
          {
            name: this.getData('reportAuthority', 'label', step)['label'],
            value: this.getData('reportAuthority', '', step)
          },

          {
            name: this.getData('copyReportAuthority', 'label', step)['label'],
            value: this.getData('copyReportAuthority', '', step)
          }
        );
        const copyReport = ['rentalNameAuthority', 'rentalReferenceNumber', 'rentalPhoneNumber', 'rentalEmail', 'rentalMyAddressLookup'];
        copyReport.forEach(fieldName => {
          if (fieldName === 'rentalMyAddressLookup') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.dataStoreService.checkAutoComplete(this.getData(fieldName + 'val', '', step) ? this.getData(fieldName + 'val', '', step) : this.getData(fieldName, '', step).formatted_address ? this.getData(fieldName, '', step).formatted_address : this.getData(fieldName, '', step))
              }
            );
          } else if (fieldName === 'rentalPhoneNumber' && uiData['rentalPhoneNumber'] !== null) {
            travelDetailsInfo.push(
              {
                name: 'Phone Number',
                value: this.phoneNumberValidation('rentalPhoneNumber')
              }
            );
          }
          else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step)
              }
            );
          }
        })

      }
      else {
        travelDetailsInfo.push(
          {
            name: this.getData('reportAuthority', 'label', step)['label'],
            value: this.getData('reportAuthority', '', step)
          }
        );
      }


    }
    // thirdparty affected start
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'thirdPartyAffected') !== undefined) {
      const thirdpartyIncidentSelect = ['heading', 'selectAllApply', 'detailsOfInjury', 'travellingCompanion'];
      thirdpartyIncidentSelect.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Third Party Incident',
              value: 'heading'
            }
          );
        }
        if (fieldName === 'selectAllApply') {
          const newArray = [];
          const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['selectAllApply'];
          CHECKBOXLITTHIRDPARTY.forEach(field => {
            chooseClaimType.forEach(element => {
              if (field.key === element.name) {
                const headingValue = field.heading;
                newArray.push(headingValue);
              }
            });
          });
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: newArray.join(', '),
            }
          );
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            }
          );
        }
      });
      const thirdpartyIncidentFault = ['considerFault'];
      thirdpartyIncidentFault.forEach(fieldName => {
        if (fieldName === 'considerFault') {
          if (uiData['considerFault'] === 'Yes' && uiData['considerFault'] !== null) {
            travelDetailsInfo.push(
              {
                name: this.getData('considerFault', 'label', step)['label'],
                value: this.getData('considerFault', '', step),
              },
              {
                name: this.getData('provideDetailsConsiderFault', 'label', step)['label'],
                value: this.getData('provideDetailsConsiderFault', '', step),
              },
            );
          } else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        }
      });
      const thirdpartyContactInfo = ['heading', 'firstName', 'lastName', 'myAddressLookupContactInfo', 'contactNumber', 'email'];
      thirdpartyContactInfo.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Third Party Contact Information',
              value: 'heading'
            });
        } else
          if (fieldName === 'myAddressLookupContactInfo') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.dataStoreService.checkAutoComplete(this.getData(fieldName + 'val', '', step) ? this.getData(fieldName + 'val', '', step) : this.getData(fieldName, '', step)?.formatted_address ? this.getData(fieldName, '', step).formatted_address : this.getData(fieldName, '', step))
              }
            );
          } else if (fieldName === 'contactNumber' && uiData['contactNumber'] !== null) {
            travelDetailsInfo.push(
              {
                name: 'Phone Number',
                value: this.phoneNumberValidation('contactNumber')
              });
          } else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
      });
    }
    // end
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'personalMoneyLost') !== undefined) {

      travelDetailsInfo.push(
        {
          name: 'Personal Money Loss',
          value: 'heading'
        });
      if (uiData['reportAuthorityMoneyLoss'] === 'Yes' && uiData['reportAuthorityMoneyLoss'] !== null) {
        travelDetailsInfo.push(
          {
            name: this.getData('tellWhatHappenedMoneyLoss', 'label', step)['label'],
            value: this.getData('tellWhatHappenedMoneyLoss', '', step)
          },
          {
            name: this.getData('dateOfLoss', 'label', step)['label'],
            value: this.getData('dateOfLoss', '', step)
          },
          {
            name: this.getData('reportAuthorityMoneyLoss', 'label', step)['label'],
            value: this.getData('reportAuthorityMoneyLoss', '', step)
          },

          {
            name: this.getData('copyReportAuthorityMoneyloss', 'label', step)['label'],
            value: this.getData('copyReportAuthorityMoneyloss', '', step)
          }
        );
        const copyReport = ['nameAuthorityMoneyLoss', 'referenceNumberMoneyLoss', 'phoneNumberMoneyLoss', 'emailMoneyLoss', 'myAddressLookupMoneyLoss'];
        copyReport.forEach(fieldName => {
          if (fieldName === 'myAddressLookupMoneyLoss') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.dataStoreService.checkAutoComplete(this.getData(fieldName + 'val', '', step) ? this.getData(fieldName + 'val', '', step) : this.getData(fieldName, '', step).formatted_address ? this.getData(fieldName, '', step).formatted_address : this.getData(fieldName, '', step))
              }
            );
          } else if (fieldName === 'phoneNumberMoneyLoss' && uiData['phoneNumberMoneyLoss'] !== null) {
            travelDetailsInfo.push(
              {
                name: 'Phone Number',
                value: this.phoneNumberValidation('phoneNumberMoneyLoss')
              }
            );
          }
          else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step)
              }
            );
          }
        });
      }
      else {
        travelDetailsInfo.push(
          {
            name: this.getData('tellWhatHappenedMoneyLoss', 'label', step)['label'],
            value: this.getData('tellWhatHappenedMoneyLoss', '', step)
          },
          {
            name: this.getData('dateOfLoss', 'label', step)['label'],
            value: this.getData('dateOfLoss', '', step)
          },
          {
            name: this.getData('reportAuthorityMoneyLoss', 'label', step)['label'],
            value: this.getData('reportAuthorityMoneyLoss', '', step)
          }
        );
      }
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingOther') !== undefined) {
      const travelBenefitType = ['heading', 'claimingForOtherFor','travelIncidentDate'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Other',
              value: 'heading'
            });
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            }
          );
        }
      });
    }
    return travelDetailsInfo.filter(e => (e.name !== undefined && e.name !== null));
  }

  /**
   * Personal Accident icon
   * @returns
   */
  personalAccidentPayload() {
    let personalPayLoad = [];
    let hospitalDocInfoIsPresent = false;
    personalPayLoad = personalPayLoad.concat(this.getPersonalAccident());
    this.personalAccident.forEach(res => {
      if (res === 'Accident Medical Reimbursement/ Daily Hospital Income/ Fracture or Dislocation') {
        personalPayLoad = personalPayLoad.concat(this.accidentalMedical('a'), this.dailyHospitalIncome('a'), this.getCreditTravel('a'), this.featureOrDisclosedPdf());
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Medical Leave Benefit') {
        personalPayLoad = personalPayLoad.concat(this.mediaclLeave('a'), this.detailsMedicalLeave());
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Permanent/Temporary Disablement') {
        personalPayLoad = personalPayLoad.concat(this.PermanentDisablement('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Accidental Death') {
        personalPayLoad = personalPayLoad.concat(this.accidentalDeath('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Other') {
        personalPayLoad = personalPayLoad.concat(this.otherDeath('a'));
      }
    });
    if (hospitalDocInfoIsPresent) {
      personalPayLoad = personalPayLoad.concat(this.hospitalDoctoreInfoPdf());
    }
    return personalPayLoad;
  }

  /**
   * @returns
   */
  hospitalDoctoreInfoPdf() {
    return this.hospitalDoctorInfo('');
  }

  drInfor() {
    const personalAccidentDetailsInfo = this.captureData('doctorInfo');
    this.hsotDrInfo = personalAccidentDetailsInfo;
    return personalAccidentDetailsInfo;
  }

  personalaccidentclaimInfo() {
    return this.personalaccidentclaimData();
  }

  /**
  *
  * @param e
  * @returns
  */
  accidentalMedical(e?) {
    let DetailsData = []
    const arraysub4 = ['heading', 'westernMedicine', 'dentalTreatment', 'mobileAdd', 'sum'];
    const uiData = this.dataStoreService.get(this.step2).uiData;
 
    arraysub4.forEach(key => {
      if (key === 'heading') {
        DetailsData.push(
          {
            name: '',
            value: 'heading'
          });
      } else {
        DetailsData.push(
          {
            name: key === 'westernMedicine' ? 'Medical Treatment' : key === 'dentalTreatment' ? 'Dental Treatment' : key === 'mobileAdd' ? 'Mobility Aid' : key === 'sum' ? 'Total Claim Amount' : '',
            value: this.dataStoreService.get(this.step2).uiData['medicalExpense'][key] ? ' ' + uiData['medicalExpense'].currency?.label + ' ' + this.decimalConverter(this.dataStoreService.get(this.step2).uiData['medicalExpense'][key], 'SG') : ' ' + uiData['medicalExpense'].currency?.label + ' 0.00'
          }
        );
      }
    })
    if (e) {
      if (DetailsData.length > 1) {
        DetailsData[0].value = ''
        const array = [{
          name: 'Accident Medical Reimbursement',
          value: 'heading'
        }];
        DetailsData = [...array, ...DetailsData];
      }
      else {
        DetailsData = [];
      }
    }
    return DetailsData;
  }

  /**
   *
   * @returns
   */
  getPersonalAccident() {
    const personalDetails = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    personalDetails.push(
      {
        name: this.getData('claimBenefits', 'label', this.step2)['label'] === 'Select Claim Type' ? 'What is the cause of your claim?' : '',
        value: this.dataStoreService.get(this.step2).uiData['claimBenefits']
      }
    );

    const arrysub1 = ['heading', 'accidentOccurred', 'injuriesSustained', 'accidentDate', 'timeIncident', 'accidentLocationLookup', 'firstVisit', 'diagnosis', 'trafficAccident', 'similarConditionPast', 'doctorsName', 'doctorsStreetAddressLookup', 'doctorsContactNumber', 'personalAccidentPast', 'multiSelectCustom', 'personalAccidentInsurance'];
    const arraysub2 = ['heading', 'chooseClaimType'];
    arrysub1.forEach(key => {
      if (key === 'heading') {
        personalDetails.push(
          {
            name: 'Personal Accident Details',
            value: 'heading'
          }
        );
      } else if (key === 'accidentLocationLookup') {
        if (this.getData(key, '', this.step2)) {
          personalDetails.push(
            {
              name: this.getData(key, 'label', this.step2)['label'],
              value: this.dataStoreService.checkAutoComplete(this.getData(key + 'val', '', this.step2) ? this.getData(key + 'val', '', this.step2) : this.getData(key, '', this.step2).formatted_address ? this.getData(key, '', this.step2).formatted_address : this.getData(key, '', this.step2))
            }
          );
        }
      } else if (key === 'similarConditionPast') {
        if (uiData['similarConditionPast'] === 'Yes' && uiData['similarConditionPast'] !== null) {
          personalDetails.push(
            {
              name: this.getData('similarConditionPast', 'label', this.step2)['label'],
              value: this.getData('similarConditionPast', '', this.step2),
            },
            {
              name: this.getData('provideDetailsSimilarConditionPast', 'label', this.step2)['label'],
              value: this.getData('provideDetailsSimilarConditionPast', '', this.step2),
            }
          );
        } else {
          personalDetails.push({
            name: this.getData('similarConditionPast', 'label', this.step2)['label'],
            value: this.getData('similarConditionPast', '', this.step2),
          });
        }
      } else if (key === 'multiSelectCustom') {
        if (uiData['multiSelectCustom']['compensationClaimIncident'].value === 'Yes') {
          personalDetails.push(
            {
              name: 'Are you claiming any other insurance or compensation in respect of this incident?',
              value: uiData['multiSelectCustom']['compensationClaimIncident'].value,
            },
            {
              name: 'Please select the type of insurance or compensation',
              value: this.insuranceType(uiData['multiSelectCustom']['selectTypeOfInsurance'].map(data => data.name).join(',')),
            },
          );
          if (uiData['multiSelectCustom']['selectTypeOfInsurance'].filter(obj => obj.id === '5').length > 0) {
            personalDetails.push({
              name: 'Other',
              value: uiData['multiSelectCustom']['provideDetailsOther'],
            });
          }
        } else if (uiData['multiSelectCustom']['compensationClaimIncident'].value === 'No') {
          personalDetails.push(
            {
              name: 'Are you claiming any other insurance or compensation in respect of this incident?',
              value: uiData['multiSelectCustom']['compensationClaimIncident'].value,
            }
          );
        }
      } else if (key === 'doctorsStreetAddressLookup') {
        if (this.getData(key, '', this.step2)) {
          personalDetails.push(
            {
              name: this.getData(key, 'label', this.step2)['label'],
              value: this.getData(key + 'val', '', this.step2) ? this.getData(key + 'val', '', this.step2) : this.getData(key, '', this.step2).formatted_address ? this.getData(key, '', this.step2).formatted_address : this.getData(key, '', this.step2)
            }
          );
        }
      } else if (key === 'doctorsContactNumber') {
        if (uiData['doctorsContactNumber'] !== null) {
          personalDetails.push(
            {
              name: this.getData('doctorsContactNumber', 'label', this.step2)['label'],
              value: this.phoneNumberValidation('doctorsContactNumber')
            },
          );
        } else {
          personalDetails.push({
            name: this.getData('doctorsContactNumber', 'label', this.step2)['label'],
            value: this.getData('doctorsContactNumber', '', this.step2),
          });
        }
      } else if (key === 'personalAccidentPast') {
        if (uiData['personalAccidentPast'] === 'Yes' && uiData['personalAccidentPast'] !== null) {
          personalDetails.push(...this.personalaccidentclaimInfo())
        } else {
          personalDetails.push({
            name: this.getData('personalAccidentPast', 'label', this.step2)['label'],
            value: this.getData('personalAccidentPast', '', this.step2),
          });
        }
      } else if (key === 'personalAccidentInsurance') {
        if (uiData['personalAccidentInsurance'] === 'Yes' && uiData['personalAccidentInsurance'] !== null) {
          personalDetails.push(
            {
              name: this.getData('personalAccidentInsurance', 'label', this.step2)['label'],
              value: this.getData('personalAccidentInsurance', '', this.step2),
            },
            {
              name: this.getData('provideDetailsHealthFund', 'label', this.step2)['label'],
              value: this.getData('provideDetailsHealthFund', '', this.step2),
            });
        } else {
          personalDetails.push({
            name: this.getData('personalAccidentInsurance', 'label', this.step2)['label'],
            value: this.getData('personalAccidentInsurance', '', this.step2),
          });
        }
      } else if (key === 'diagnosis') {
        if (key.indexOf('diagnosis') > -1) {
          personalDetails.push(
            {
              name: this.getData('diagnosis', 'label', this.step2)['label'],
              value: this.getData('diagnosis', '', this.step2),
            }
          );
        }
        if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosis']?.id === '13') {
          personalDetails.push(
            {
              name: this.getData('otherDia', 'label', this.step2)['label'],
              value: this.getData('otherDia', '', this.step2),
            });
        }
      } else {
        if (this.dataStoreService.get(this.step2)?.uiData[key] !== 'diagnosis') {
          if (this.getData(key, '', this.step2)) {
            personalDetails.push(
              {
                name: this.getData(key, 'label', this.step2)['label'],
                value: this.getData(key, '', this.step2)
              }
            );
          }
        }
      }
    });
    arraysub2.forEach(key => {
      if (key === 'heading') {
        personalDetails.push(
          {
            name: 'Personal Accident Benefits',
            value: 'heading'
          }
        );
      } else {
        const newArray = [];
        this.personalAccident = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimType'];
        CHECKBOXLITEPERSONAL.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(headingValue);
              this.personalAccident.push(headingValue);
            }
          });
        });
        personalDetails.push(
          {
            name: this.getData(key, 'label', this.step2)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });
    return personalDetails.filter(e => (e.name !== undefined && e.name !== null));
  }

  getOtherDetails() {
    return this.getOtherDetailsData('claimForOther', 'otherDate');
  }

  /**
   *
   * @param data
   * @returns
   */
  dailyHospitalIncome(data?) {
    let personalAccidentDetailsInfo = this.captureData('admittedHospital');
    if (data && personalAccidentDetailsInfo.length > 0) {
      personalAccidentDetailsInfo = [{
        name: 'Daily Hospital Income',
        value: 'heading'
      }, ...personalAccidentDetailsInfo];
    }
    return personalAccidentDetailsInfo;
  }

  mediaclLeave(e?) {
    return this.mediaclLeaveData('Medical Leave', '', e);
  }

  detailsMedicalLeave() {
    const personalAccidentDetails = ['employed', 'dateOfExpected'];
    const personalAccidentDetailsInfo = this.captureData(personalAccidentDetails);
    return personalAccidentDetailsInfo;
  }

  PermanentDisablement(e?) {
    const permanentDi = ['dateOfDisability', 'typeDisability', 'otherCauseDisability'];
    let disabilityData = this.captureData(permanentDi);

    if (e && disabilityData.length > 0) {
      disabilityData = [{
        name: 'Permanent/Temporary Disablement',
        value: 'heading'
      }, ...disabilityData];
    }
    return disabilityData;
  }

  accidentalDeath(e?) {
    const permanentDi = ['dateOfDeath', 'localTimePersonal', 'causeDeath', 'autopsy', 'fullName', 'relationName', 'phoneNumberPersonal', 'emailAddress'];
    let disablityData = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;
    permanentDi.forEach((res) => {
      if (res === 'phoneNumberPersonal') {
        const data = this.getData('phoneNumberPersonal', '', this.step2);
        if (data) {
          disablityData.push(
            {
              'name': 'Phone Number',
              'value': this.phoneNumberValidation('phoneNumberPersonal')
            }
          );
        }
      } else if (res === 'autopsy') {
        if (uiData['autopsy'] === 'No' && uiData['autopsy'] !== null) {
          disablityData.push(
            {
              name: this.getData('autopsy', 'label', this.step2)['label'],
              value: this.getData('autopsy', '', this.step2),
            },
            {
              name: this.getData('reason', 'label', this.step2)['label'],
              value: this.getData('reason', '', this.step2),
            });
        } else {
          disablityData.push({
            name: this.getData('autopsy', 'label', this.step2)['label'],
            value: this.getData('autopsy', '', this.step2),
          });
        }
      } else {
        if (this.getData(res, '', this.step2)) {
          disablityData.push(
            {
              name: this.getData(res, 'label', this.step2)['label'],
              value: this.getData(res, '', this.step2)
            }
          );
        }
      }
    });

    if (e && disablityData.length > 0) {
      const array = [{
        name: 'Accidental Death Details',
        value: 'heading'
      }];

      disablityData = [...array, ...disablityData];
    }
    return disablityData;
  }

  otherDeath(e?) {
    return this.otherDeathData('', e);
  }

  featureOrDisclosedPdf() {
    const array = [{
      name: 'Fracture  or Dislocation',
      value: 'heading'
    }];
    const data = [...array, this.fractureList('sustainFracture'), ...this.featureOrDisclosed(),
    this.fractureList('sustainDislocation'), ...this.siteDisclosed()];
    return data.filter(e => (e.name !== undefined));
  }

  featureOrDisclosed() {
    const nonBagNoEMp = ['siteFracture', 'typeFracture'];
    const travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addFractureMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'sustainFracture' });
    return travelArr.filter(e => (e.name !== undefined));
  }

  siteDisclosed() {
    const nonBagNoEMp = ['siteDislocation'];
    const travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addDislocationMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'sustainDislocation' });
    return travelArr.filter(e => (e.name !== undefined));
  }

  getCreditTravel(data?) {
    const nonBagNoEMp = ['nameClinic', 'dateOfAdmission', 'timeAdmission', 'dateOfDischarge', 'timeDischarge'];
    let travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addTreatmentMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'admittedHospital' });

    if (data && travelArr.length > 0) {
      travelArr = [{
        name: 'Hospitalization details',
        value: 'heading'
      }, ...travelArr];
    }
    return travelArr.filter(e => (e.name !== undefined && e.name !== null));
  }

  getUploadDetails(step) {
    return this.getUploadDetailsData(step);
  }

}